import clsx from "clsx";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface SubMenuGridProps {
  layout?: "equidistant" | "centralFocus";
  children: ReactNode;
}

const SubMenuGrid = ({ layout = "equidistant", children }: SubMenuGridProps) => {
  const layoutClasses = clsx({
    "grid-cols-3": layout === "equidistant",
    "grid-cols-[29%_42%_29%]": layout === "centralFocus",
  });

  return <div className={twMerge("grid gap-[1px] bg-fog-20", layoutClasses)}>{children}</div>;
};

export { SubMenuGrid };
